<template>
    <div v-cloak v-if="auth">
        <div class="row mb-3">
            <div class="col-12">
                <div class="row form-group">
                    <div class="col-12"><label for="history-search">{{ $lang('Odbiorca mailingu:') }}</label></div>
                    <div class="col-8 col-md-10">
                        <input
                            class="form-control d-inline-block w-100 w-md-auto mr-3"
                            id="history-search"
                            type="text"
                            v-model="search"
                            @keydown="searchInputKeyDown"
                            :placeholder="$lang('Wyszukaj odbiorcę') + '...'"
                        >
                    </div>
                    <div class="col-4 col-md-2 form-group">
                        <button class="btn btn-primary btn-block text-nowrap" @click.prevent="searchButtonClick">
                            <span>{{ $lang('Szukaj') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
        <div class="simple-table structure-table" v-if="mailingHistoryList.length">
            <table class="table table-striped table-sm table-hover mb-0">
                <table-headers :headers="tableHeaders"></table-headers>
                <tbody>
                    <tr v-for="(historyEmail, index) in mailingHistoryList">
                        <td :data-title="$lang('Lp.')">
                            {{ pagination.from + index }}
                        </td>
                        <td :data-title="$lang('Tytuł')">
                            <span>{{ historyEmail.subject }}</span>
                        </td>
                        <td :data-title="$lang('Odbiorca')">
                            <span>{{ historyEmail.recipient_email }}</span>
                        </td>
                        <td :data-title="$lang('Otworzony')">
                            <span v-if="historyEmail.meta && historyEmail.meta.invalid_address">
                                {{ $lang('Nieistniejący adres') }}
                            </span>
                            <span v-else>
                                {{ historyEmail.opened_at ? parseDateTime(historyEmail.opened_at) : $lang('Brak danych') }}
                            </span>
                        </td>
                        <td :data-title="$lang('Wysłany')">
                            <span>{{ parseDateTime(historyEmail.created_at)  }}</span>
                        </td>
                        <td :data-title="$lang('Akcje')">
                            <a href="#"
                               @click.prevent="showPreviewModal('PREVIEW', historyEmail.id)"
                               class="mx-1"
                               :title="$lang('Podgląd')  + ': ' +  historyEmail.subject"
                               :aria-label="$lang('Podgląd') + ': ' +  historyEmail.subject">
                                {{ $lang('Podgląd') }}
                            </a>
                            <a href="#"
                               @click.prevent="showPreviewModal('STATISTICS', historyEmail.id)"
                               class="mx-1"
                               :title="$lang('Statystyki')  + ': ' +  historyEmail.recipient_email"
                               :aria-label="$lang('Statystyki') + ': ' +  historyEmail.recipient_email">
                                {{ $lang('Statystyki') }}
                            </a>
                            <i
                                v-if="mailing_history.draft.attachments
                                && mailing_history.draft.attachments.length > 3
                                && !historyEmail.content.includes('Kampania mailowa o temacie:')"
                                :title="$lang('Mailing zawiera załącznik')"
                                aria-hidden="true"
                                class="fa fa-paperclip pull-right"
                            ></i>
                        </td>

                        <div class="modal fade" :id="'preview-modal-' + historyEmail.id" tabindex="-1">
                            <div class="modal-dialog modal-lg modal-email">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">{{$lang('Podgląd')}}</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div v-html="historyEmail.content"></div>
                                        <div class="col-12" v-if="mailing_history.draft.attachments && mailing_history.draft.attachments.length > 3
                                                                  && !historyEmail.content.includes('Kampania mailowa o temacie:')">
                                            <strong>
                                                <i aria-hidden="true" class="fa fa-paperclip mr-1"> {{ $lang("Załączniki") }}:</i>
                                            </strong>
                                            <ul>
                                                <li v-for="(filename) in getAttachments(mailing_history.draft.attachments)">
                                                    {{ filename }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-default" data-dismiss="modal" :id="'close-' + historyEmail.id">
                                            {{$lang('Zamknij')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal fade" :id="'statistics-modal-' + historyEmail.id" tabindex="-1">
                            <div class="modal-dialog modal-lg">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">{{$lang('Statystyki')}}</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body text-break">
                                        <dl class="col-12 col-lg-12 float-left mt-2">
                                            <h4>{{ $lang('Wyświetlenia') }}</h4>
                                            <div class="col-12 float-left">
                                                <dt class="col-6 float-left">
                                                    {{ $lang('Data pierwszego wyświetlenia')}}:
                                                </dt>
                                                <dd class="col-6 float-left">
                                                    {{ historyEmail.opened_at ? parseDateTime(historyEmail.opened_at) : 'Brak danych' }}
                                                </dd>
                                            </div>
                                            <div class="col-12 float-left mb-4">
                                                <dt class="col-6 float-left">
                                                    {{ $lang('Liczba wyświetleń')}}:
                                                </dt>
                                                <dd class="col-6 float-left">
                                                    {{ historyEmail.opens }}
                                                </dd>
                                            </div>

                                            <h4 class="">{{ $lang('Informacje o linkach') }}</h4>
                                            <div class="col-12 float-left">
                                                <dt class="col-6 float-left">
                                                    {{ $lang('Data pierwszego kliknięcia w link')}}:
                                                </dt>
                                                <dd class="col-6 float-left">
                                                    {{ historyEmail.clicked_at ? parseDateTime(historyEmail.clicked_at) : 'Brak danych' }}
                                                </dd>
                                            </div>
                                            <div>
                                                <div class="col-12 float-left mb-4">
                                                    <dt class="col-6 float-left">
                                                        {{ $lang('Liczba wszystkich kliknięć w link')}}:
                                                    </dt>
                                                    <dd class="col-6 float-left">
                                                        {{ historyEmail.clicks }}
                                                    </dd>
                                                </div>
                                            </div>
                                            <h4 v-if="historyEmail.url_clicks.length > 0" class="">{{ $lang('Linki') }}</h4>
                                            <ul v-if="historyEmail.url_clicks.length > 0">
                                                <div v-for="link in historyEmail.url_clicks">
                                                    <li>
                                                        <span>{{ link.url }}</span>
                                                    </li>
                                                    <div class="col-12 float-left pl-0">
                                                        <dt class="col-6 float-left pl-0">
                                                            {{ $lang('Liczba kliknięć w link')}}:
                                                        </dt>
                                                        <dd class="col-6 float-left pl-0">
                                                            {{ link.clicks }}
                                                        </dd>
                                                    </div>
                                                </div>
                                            </ul>
                                        </dl>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-default" data-dismiss="modal" :id="'close-' + historyEmail.id">
                                            {{$lang('Zamknij')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            {{ $lang('Brak wyników') }}
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>

    </div>
</template>
<script>

    import axios from 'axios';
    import Notification from '../../../mixins/show-notification';
    import { EventBus } from "../../../mixins/event-bus";
    import TableHeaders from '../../table/table-headers';
    import PaginationComponent from '../../pagination-component';

    export default {

        name: 'mailing-history-details-table',

        components: {
            TableHeaders,
            PaginationComponent,
        },

        mixins: [Notification],

        props: {
            auth: {
                type: Boolean,
                required: true
            },
            list_route: {
                type: String,
            },
            history_route: {
                type: String,
            },
            mailing_history: {
              type: Object,
              required: true
            },
        },

        data() {
            return {
                mailingHistoryList: [],
                pagination: [],
                perPage: 20,
                sortColumn: 'created_at',
                sortOrder: 'asc',
                search: '',
                tableHeaders: [
                    {title: this.$lang('Lp.')},
                    {title: this.$lang('Tytuł')},
                    {title: this.$lang('Odbiorca'), column: 'recipient_email', sort: 'alpha'},
                    {title: this.$lang('Otworzony'), column: 'opened_at', sort: 'numeric'},
                    {title: this.$lang('Wysłany'), column: 'created_at', sort: 'numeric'},
                    {title: this.$lang('Akcje')}
                ],
            };
        },
        created() {
            this.setEventBusListeners();
            this.requestHistory();
        },

        watch: {
            sortColumn() {
                this.requestHistory();
            }
        },

        methods: {
            requestHistory(filters) {
                const params = {
                    ...filters,
                    perPage: this.perPage,
                    search: this.search,
                    sortColumn: this.sortColumn,
                    sortOrder: this.sortOrder,
                    mailingId: this.mailing_history.id
                };
                return axios.get(this.list_route, { params }).then((response) => {
                    this.mailingHistoryList = response.data.data;
                    this.pagination = response.data;
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message);
                });
            },

            searchInputKeyDown(event) {
                if (event.keyCode === 13) {
                    this.requestHistory();
                }
            },

            searchButtonClick() {
                this.requestHistory();
            },

            setEventBusListeners() {
                EventBus.$on('changePage', ({ value }) => {
                    this.requestHistory({ page: value });
                });

                EventBus.$on('sortByColumn', ({ column, order }) => {
                    this.sortColumn = column;
                    this.sortOrder = order;

                    this.requestHistory({ page: this.pagination.current_page });
                });
            },
            showPreviewModal(type, id) {
                if (type === 'PREVIEW' ) {
                    $("#preview-modal-" + id).modal("show");
                }
                if (type === 'STATISTICS' ) {
                    $("#statistics-modal-" + id).modal("show");
                }
            },
            parseDateTime(datetime) {
                let date = new Date(datetime);
                return ("0" + date.getDate()).slice(-2) + '-' + ("0" + (date.getMonth() + 1)).slice(-2)  + '-' + date.getFullYear()  + ' ' +  date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
            },
            getAttachments: function (history) {
                if (history.length > 3) {
                    history = JSON.parse(history);
                    history = history.map(attachment => attachment.filename);
                }

                return history;
            },
        },

    }

</script>
